import React from 'react'
import Codingimage from "./codingQuiz.jpg"

export default function Codingquiz() {
  return (
    <img className ="w-64 m-auto rounded-lg hover:w-96 hover:ease-in duration-300" src={Codingimage}></img>
  )
}
